import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var routes = [
    {
        path: '/',
        name: 'Home',
        // redirect: '/login'
        component: () => import(`@/components/LoginPage`)
        // component: () => import(`@/pages/indexPage`)
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(`@/components/LoginPage`)
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => import(`@/components/LogoutPage`)
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(`@/components/register`)
    },
    {
      path: '/metabase/:tab',
      name: 'metabase',
      component: () => import(`@/components/dashboard`)
    },
    {
        path: '/rms',
        component: () => import(`@/components/DashboardLayout`),
        children: [
            {
                path: 'password',
                name: 'Password',
                component: () => import(`@/components/Password`)
            },
            {
                path: '/',
                redirect: 'registration'
            },
            {
                path: 'dashboard',
                name: 'adminDashboard',
                component: () => import(`@/pages/dashboard/Dashboard`)
            },
            {
                path: 'registration',
                name: 'adminRegistration',
                component: () => import(`@/pages/case/add`),
                meta: {
                    keepAlive: false // 不需要被缓存
                }
            },
            {
                path: 'registration/:pk',
                name: 'adminRegistrationEdit',
                component: () => import(`@/pages/case/add`),
                meta: {
                    keepAlive: false // 不需要被缓存
                }
            },
            {
                path: 'archives',
                name: 'adminArchives',
                component: () => import(`@/pages/case/list`)
            },
            {
                path: 'report/costStatistics',
                name: 'report_costStatistics',
                component: () => import(`@/pages/charts/feiyongCharts`)
            },
            {
                path: 'report/diseaseCtrlChart',
                name: 'report_diseaseCtrlChart',
                component: () => import(`@/pages/charts/dataCharts`)
            },
            {
                path: 'report/diseaseAnalysisChart',
                name: 'report_diseaseAnalysisChart',
                component: () => import(`@/pages/charts/lifelinesCharts`)
            },
            {
                path: 'report/statistics',
                name: 'statistics',
                component: () => import(`@/pages/charts/statistics`)
            },
            {
                path: 'report/jupyter',
                name: 'jupyter',
                component: () => import(`@/pages/charts/jupyterhub`)
            },
            {
                path: 'system/user',
                name: 'system_user',
                component: () => import(`@/pages/system/user`)
            },
            {
                path: 'institution',
                name: 'institution',
                component: () => import(`@/pages/institution`)
            },
            {
                path: 'help',
                name: 'Help',
                component: () => import(`@/pages/help`)
            },
            {
                path: 'dowload',
                name: 'dowload',
                component: () => import(`@/pages/dowload/index`)
            },
            {path: '*', component: () => import('@/components/NotFoundPage')}
        ]
    },
    {path: '*', component: () => import('@/components/NotFoundPage')}
]

export default new Router({routes})
